/* src/app/shared/components/signalrify/signalrify.component.scss */
@keyframes dots {
  0% {
    text-indent: 0;
  }
  33.33% {
    text-indent: 1ch;
  }
  66.66% {
    text-indent: 2ch;
  }
  100% {
    text-indent: 3ch;
  }
}
.status::after {
  font-family: "Material Icons";
  font-size: 0.8em;
  line-height: 1;
}
.status.connecting {
  bottom: 1em;
  right: 2.5em;
}
.status.connecting::after {
  content: "\e5d3";
  display: inline-block;
  width: 3ch;
  overflow: hidden;
  white-space: nowrap;
  animation: dots 1s steps(1, end) infinite;
}
.status.connected::after {
  content: "\e157";
}
.status.disconnected::after {
  content: "\e16f";
}
:host(.signalrify) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: inherit;
}
/*# sourceMappingURL=signalrify.component.css.map */
